import { render, staticRenderFns } from "./CompanyDiscountDetails.vue?vue&type=template&id=47a825cd"
import script from "./CompanyDiscountDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDiscountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports